define('viewModels/privileged/qm/CreateCalibrationView',[
    'lib/knockout',
    'lib/lodash4',
    'viewModels/privileged/qm/policies/editors/AgentSelectorView',
    'viewModels/privileged/qm/util/ServiceResponseValidator',
    'viewModels/privileged/composer/forms/formEditor/QuestionGroup',
    'viewModels/ViewModel',
    'services/authService',
    'services/navHelper',
    'services/qualityManagementService'
], function (
             ko,
             _,
             AgentSelectorView,
             ServiceResponseValidator,
             QuestionGroup,
             ViewModel,
             authService,
             navHelper,
             qualityManagementService
    ) {
    "use strict";

    var CreateCalibrationView = ViewModel.extend(function (evaluation) {
        var self = this;
        self.calibration = ko.observable();
        self.saving = ko.observable(false);

        var responseValidator = new ServiceResponseValidator();
        self.evaluators = ko.observableArray([]).extend({responseValidator: responseValidator});

        self.calibration = {
            calibrator: { id: authService.principalId() },
            conversation: { id: evaluation.conversation.id },
            agent: { id: evaluation.agent.id }
        };

        self.userSelector = self.subView(AgentSelectorView, self.evaluators);

        self.calibration.scoringIndex = {
            id: evaluation.id,
            conversation: {id : evaluation.conversation.id },
            evaluationForm: { id: evaluation.evaluationForm.id,
                              name: evaluation.evaluationForm.name,
                              published: evaluation.evaluationForm.published},
            evaluator: { id: evaluation.evaluator.id }
        };

        self.createCalibration = function() {

            var evaluatorArray = [];

            _.each(self.userSelector.agents(), function(evaluator) {
                evaluatorArray.push({id: evaluator.id});
            });

            self.calibration.evaluators = evaluatorArray;

            self.saving(true);
            qualityManagementService.createCalibration(self.calibration)
                .then(function(response) {
                    responseValidator.handleSuccess();
                    var destination = 'admin/interactions/' + response.conversation.id + '/calibrations/' + response.id;
                    navHelper.navigateTo(destination);
                })
                .catch(responseValidator.createErrorCallback({ namespace: "calibration.createCalibrationRequest"}))
                .finally(function () {
                    self.saving(false);
                });
        };

    });
    return CreateCalibrationView;
});

